/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FetchV2Request} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {FetchV2Response} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const fetchV2 = (request:FetchV2Request, options?: CashRequestOptions) => post<FetchV2Request, FetchV2Response>("/2.0/cash/fetch-v2", request, {...options, rejectOnError: true })